/* eslint-disable max-lines */
import { v4 as uuidV4 } from 'uuid'
import { getFullQiNiuPath } from '@/utils/qiniu'
import { getImageInfoFromUrl } from '@/components/Uploader/utils'
import { isNumber, extractPicFromHtml } from '@/utils/utils'
import { ERROR_TYPE, AUTO_PEPLACE_TYPE } from './constants'

export const defaultFailurePic = 'https://assets.sursung.com/pkg/static/imgs/202102/gylPic/failurePic.png'

export const defaultFailureVideo =
    'https://assets.sursung.com/activity/20241029/8C8EF8CCDB74487288B38BD4A7B6C9661730190864910.png'

export const clean = value => {
    if (Array.isArray(value)) {
        return value
            .map((item, index) => ({
                ...item,
                _index: index // 处理非主图不校验
            }))
            .filter(item => !item.isBtn)
    }

    return []
}

const KID = 1001

export class BtnControl {
    kid = KID
    kidMap = {}

    getKid() {
        let id = ++this.kid

        return id
    }
}

export const transValueToData = value => {
    const fn = v => {
        return v && v.status === 'done' ? v.url : undefined
    }

    if (Array.isArray(value)) {
        return value.map(fn).filter(Boolean)
    }

    return fn(value)
}

export const transDataToValue = (data, extra) => {
    const fn = v => {
        if (!v) {
            return
        }

        return {
            uid: uuidV4(),
            url: getFullQiNiuPath(v),
            status: 'done',
            ...(extra || {})
        }
    }

    if (Array.isArray(data)) {
        return data.map(fn).filter(Boolean)
    }

    return fn(data)
}

export const uploadingArrayValidator = value => {
    if (value.some(v => v.status === 'failurePic' || v.status === 'error' || (v.status === 'done' && !v.url))) {
        return Promise.reject(new Error('请处理失效图片'))
    } else if (value.some(v => v.url === defaultFailurePic)) {
        return Promise.reject(new Error('请处理失效图片'))
    } else if (value.some(v => v.status !== 'done' && v.status !== 'error')) {
        return Promise.reject(new Error('正在上传...'))
    }

    return Promise.resolve()
}

export const uploadingItemValidator = value => {
    if (value.status === 'failurePic' || value.status === 'error' || (value.status === 'done' && !value.url)) {
        return Promise.reject(new Error('请处理失效图片'))
    } else if (value.url === defaultFailurePic) {
        return Promise.reject(new Error('请处理失效图片'))
    } else if (value.status !== 'done' && value.status !== 'error') {
        return Promise.reject(new Error('正在上传...'))
    }

    return Promise.resolve()
}

export const uploadingValidator = {
    validator(rule, value) {
        if (!value) {
            return Promise.resolve()
        }

        if (Array.isArray(value)) {
            return uploadingArrayValidator(clean(value))
        } else {
            return uploadingItemValidator(value)
        }
    }
}

// 富文本图片失效
export const uploadingRichTextImgValidator = {
    validator(rule, value) {
        if (value?.data && typeof value?.data === 'string') {
            const imglist = extractPicFromHtml(value.data)
            if (Array.isArray(imglist) && imglist.length > 0 && imglist.some(v => v === defaultFailurePic)) {
                return Promise.reject(new Error('请处理失效图片'))
            }
        }
        return Promise.resolve()
    }
}

export const uploadingVideoArrayValidator = value => {
    if (value.some(v => v.status === 'failurePic' || v.status === 'error' || (v.status === 'done' && !v.url))) {
        return Promise.reject(new Error('请处理失效视频'))
    } else if (value.some(v => v.url === defaultFailurePic)) {
        return Promise.reject(new Error('请处理失效视频'))
    } else if (value.some(v => v.status !== 'done' && v.status !== 'error')) {
        return Promise.reject(new Error('正在上传...'))
    }

    return Promise.resolve()
}

export const uploadingVideoItemValidator = value => {
    if (value.status === 'failurePic' || value.status === 'error' || (value.status === 'done' && !value.url)) {
        return Promise.reject(new Error('请处理失效视频'))
    } else if (value.url === defaultFailurePic) {
        return Promise.reject(new Error('请处理失效视频'))
    } else if (value.status !== 'done' && value.status !== 'error') {
        return Promise.reject(new Error('正在上传...'))
    }

    return Promise.resolve()
}

export const uploadingVideoValidator = {
    validator(rule, value) {
        if (!value) {
            return Promise.resolve()
        }

        if (Array.isArray(value)) {
            return uploadingVideoArrayValidator(clean(value))
        } else {
            return uploadingVideoItemValidator(value)
        }
    }
}

// 把备用与主图转化为单个数据 (溢出处理与空白补充按钮)
const btnControl = new BtnControl()
export const transMainSpareToValue = ({ mainImage, spareImage, mainNum }) => {
    const list = []
    const mainImages = mainImage.slice()

    for (let i = 0; i < mainNum; i++) {
        const item = mainImages.shift()

        if (item) {
            list.push({
                ...item,
                location: i + 1,
                main: true
            })
        } else {
            list.push({ isBtn: true, main: true, uid: `btn_${btnControl.getKid()}` })
        }
    }

    return list.concat(mainImages, spareImage)
}

const INDEX_4 = 4

// 把备用与主图转化为单个数据 (溢出处理与空白补充按钮) 淘宝填充白色背景
export const transMainSpareFillWhiteImageToValue = ({ mainImage, spareImage, whiteImage = '', mainNum }) => {
    const list = []
    const mainImages = mainImage.slice()

    for (let i = 0; i < mainNum; i++) {
        const item = mainImages.shift()

        if (i === INDEX_4 && whiteImage) {
            list.push({
                ...item,
                ...transDataToValue(whiteImage),
                location: i + 1
            })
        } else {
            if (item) {
                list.push({
                    ...item,
                    location: i + 1,
                    main: true
                })
            } else {
                list.push({ isBtn: true, main: true, uid: `btn_${btnControl.getKid()}` })
            }
        }
    }

    return list.concat(mainImages, spareImage)
}

// 把单个数据转化为主图与备用
export const transMainSpareToData = ({ list, mainNum }) => {
    const images = Array.isArray(list) ? list.slice() : []
    const mainList = clean(images.splice(0, mainNum))
    const spareList = clean(images)

    return {
        mainImage: Array.isArray(mainList) ? transValueToData(mainList) : [],
        spareImage: Array.isArray(spareList) ? transValueToData(spareList) : []
    }
}

// 按照规则转化list
export const transRulesToList = ({ list, mainNum, maxNum }) => {
    const oldList = list.slice(0, maxNum || 50) // 默认50
    const newList = []
    let location = 0

    for (let i = 0; i < mainNum; i++) {
        const item = oldList.shift()

        if (item) {
            if (item.isBtn) {
                newList.push({
                    ...item,
                    main: true
                })
            } else {
                newList.push({
                    ...item,
                    location: ++location,
                    main: true
                })
            }
        } else {
            newList.push({ isBtn: true, main: true, uid: `btn_${btnControl.getKid()}` })
        }
    }

    oldList.forEach(item => {
        if (!item.isBtn) {
            newList.push({
                ...item,
                location: null,
                main: false
            })
        }
    })

    return newList
}

// 多图上传填空白
export const valueFillBlanks = ({ value, items, index }) => {
    let i = index

    function insert(list, index, item) {
        if (list.some(item2 => item2.uid === item.uid)) {
            return list.map(item3 => {
                if (item3.uid === item.uid) {
                    return item
                } else {
                    return item3
                }
            })
        } else {
            if (i > list.length - 1) {
                i++
                return list.concat(item)
            } else {
                if (!list[index].url) {
                    list.splice(index, 1, item)
                    i++
                    return list
                } else {
                    i++
                    return insert(list, i, item)
                }
            }
        }
    }

    const newValue = items.reduce(
        (list, item) => {
            return insert(list, i, item)
        },
        Array.isArray(value) ? value.slice() : []
    )

    // console.log('newValue', newValue)

    return newValue
}

// 从URL获取图片信息验证 【生成对应平台的图片检验新规则】
// 检查大小
const checkSizeFromImageUrl = params => {
    const { size, minSize, maxSize } = params || {}

    if (!isNumber(size)) {
        return true
    }

    if (isNumber(minSize)) {
        if (size < minSize * 1024 * 1024) {
            return false
        }
    }

    if (isNumber(maxSize)) {
        if (size > maxSize * 1024 * 1024) {
            return false
        }
    }

    return true
}

// 检查尺寸
const checkRectFromImageUrl = params => {
    const { minWidth, maxWidth, minHeight, maxHeight, width, height } = params || {}

    if (!width || !height) {
        return true
    }

    if (
        typeof minWidth === 'undefined' &&
        typeof maxWidth === 'undefined' &&
        typeof minHeight === 'undefined' &&
        typeof maxHeight === 'undefined'
    ) {
        return true
    }

    try {
        if (
            (minWidth && width < minWidth) ||
            (maxWidth && width > maxWidth) ||
            (minHeight && height < minHeight) ||
            (maxHeight && height > maxHeight)
        ) {
            return false
        }
    } catch (e) {
        console.error('catchError', e)
        return true
    }
    return true
}

// 检查格式
const checkTypeFromImageUrl = params => {
    const { imgType, acceptTypeList = [], noAcceptTypeList = [] } = params || {}

    if (!imgType) {
        return true
    }

    if (Array.isArray(acceptTypeList) && acceptTypeList.length > 0) {
        const isExist = acceptTypeList.some(v => v?.toLowerCase() === imgType?.toLowerCase())
        if (!isExist) {
            return false
        }
    }

    if (Array.isArray(noAcceptTypeList) && noAcceptTypeList.length > 0) {
        const isExist = noAcceptTypeList.some(v => v?.toLowerCase() === imgType?.toLowerCase())
        if (isExist) {
            return false
        }
    }

    return true
}

// 检查宽高比例 (ratio：可以是比例值或数组（多个）)
export const checkRatioFromImageUrl = params => {
    const { ratio, maxRatio, ratioDiffScope, width, height } = params || {}

    if (!width || !height) {
        return true
    }

    // 如果超出最大宽高比
    if (typeof maxRatio !== 'undefined') {
        const isOutMaxRatio = maxRatio ? width / height > maxRatio : false
        if (isOutMaxRatio) {
            return false
        }
    }

    if (typeof ratio === 'undefined') {
        return true
    }

    if (ratio) {
        const fixedNum = 4
        if (Array.isArray(ratio)) {
            const isConformArr = ratio.filter(r => {
                const actualRatio = width / height

                if (ratioDiffScope) {
                    return Math.abs(actualRatio - r).toFixed(fixedNum) <= ratioDiffScope
                } else {
                    return actualRatio === r
                }
            })

            if (isConformArr.length === 0) {
                return false
            }
        } else {
            const isConform = ratioDiffScope
                ? Math.abs(width / height - ratio).toFixed(fixedNum) < ratioDiffScope
                : width / height === ratio
            if (!isConform) {
                return false
            }
        }
    }

    return true
}

export const getRatioStrByRatio = ratio => {
    for (let h = 1; h < 100; h++) {
        const w = ratio * h
        // w 是否近似为整数
        if (w.toFixed(2).endsWith('.00')) {
            return `${w.toFixed()}:${h}`
        }
    }
}

export const imageUrlValidatorParam = customImageRules => {
    const { validatorNum, ...otherProps } = customImageRules || {}

    let sizeValidator = customImageRules?.sizeValidator // 大小
    let rectValidator = customImageRules?.rectValidator // 尺寸
    let imageTypeValidator = customImageRules?.imageTypeValidator // 类型
    let ratioValidator = customImageRules?.ratioValidator // 比例
    let customizeValidator = customImageRules?.customizeValidator // 自定义

    // 兼容打平的数据传参
    // 大小
    if (!sizeValidator && (otherProps?.minSize || otherProps?.maxSize)) {
        const { name, minSize, maxSize } = otherProps || {}
        sizeValidator = {
            name,
            minSize,
            maxSize
        }
    }

    // 尺寸
    if (
        (!rectValidator &&
            (otherProps?.minWidth || otherProps?.maxWidth || otherProps?.minHeight || otherProps?.maxHeight)) ||
        otherProps?.maxTotalHeight
    ) {
        const { name, minWidth, maxWidth, minHeight, maxHeight, maxTotalHeight } = otherProps || {}
        rectValidator = {
            name,
            minWidth,
            maxWidth,
            minHeight,
            maxHeight,
            maxTotalHeight
        }
    }

    // 类型
    if (!imageTypeValidator && otherProps?.acceptTypeList) {
        const { name, acceptTypeList, noAcceptTypeList } = otherProps || {}
        imageTypeValidator = {
            name,
            acceptTypeList,
            noAcceptTypeList
        }
    }

    // 比例
    if (!ratioValidator && otherProps?.ratio) {
        const { name, ratio, maxRatio, ratioDiffScope } = otherProps || {}
        ratioValidator = {
            name,
            ratio,
            maxRatio,
            ratioDiffScope
        }
    }

    return {
        validatorNum,
        sizeValidator,
        rectValidator,
        imageTypeValidator,
        ratioValidator,
        customizeValidator,
        otherProps
    }
}

// 图片容量大小
const itemSizeValidator = ({ sizeValidator, size, i, isMulti, otherProps }) => {
    const { minSize = 0, maxSize = undefined, name = '' } = sizeValidator || {}
    const checkData = {
        minSize,
        maxSize,
        size
    }
    const checkSizeResult = checkSizeFromImageUrl(checkData)
    if (!checkSizeResult) {
        return {
            index: i + 1,
            msg: isMulti ? `${name || otherProps?.name || '图片'}${i + 1}大小不合法` : '大小不合法',
            type: ERROR_TYPE.SIZE,
            validator: sizeValidator
        }
    }
}

// 尺寸宽高（像素）
const itemRectValidator = ({ rectValidator, width, height, i, isMulti, otherProps }) => {
    const { minWidth, maxWidth, minHeight, maxHeight, name = '' } = rectValidator || {}
    const checkData = {
        minWidth,
        maxWidth,
        minHeight,
        maxHeight,
        width,
        height
    }
    const checkRectResult = checkRectFromImageUrl(checkData)
    if (!checkRectResult) {
        return {
            index: i + 1,
            msg: isMulti ? `${name || otherProps?.name || '图片'}${i + 1}尺寸不合法` : '尺寸不合法',
            type: ERROR_TYPE.RECT,
            validator: rectValidator
        }
    }
}

// 图片格式
const itemImageTypeValidator = ({ imageTypeValidator, imgType, i, isMulti, otherProps }) => {
    const { acceptTypeList = [], noAcceptTypeList = [], name = '' } = imageTypeValidator || {}
    const checkData = {
        acceptTypeList,
        noAcceptTypeList,
        imgType
    }
    const checkTypeResult = checkTypeFromImageUrl(checkData)
    if (!checkTypeResult) {
        return {
            index: i + 1,
            msg: isMulti ? `${name || otherProps?.name || '图片'}${i + 1}格式不合法` : '格式不合法',
            type: ERROR_TYPE.TYPE,
            validator: imageTypeValidator
        }
    }
}

// 宽高比例
const itemRatioValidator = ({ ratioValidator, width, height, i, isMulti, otherProps }) => {
    const { ratio, maxRatio, ratioDiffScope, name = '' } = ratioValidator || {}
    const checkData = {
        ratio,
        maxRatio,
        ratioDiffScope,
        width,
        height
    }
    const checkRatioResult = checkRatioFromImageUrl(checkData)
    if (!checkRatioResult) {
        const ratioErrMsg = Array.isArray(ratio)
            ? ratio.map(_ => getRatioStrByRatio(_)).join('或')
            : getRatioStrByRatio(ratio)

        return {
            index: i + 1,
            msg: isMulti
                ? `${name || otherProps?.name || '图片'}${i + 1}宽高比例需要${ratioErrMsg}`
                : `宽高比例需要${ratioErrMsg}`,
            type: ERROR_TYPE.RATIO,
            validator: ratioValidator
        }
    }
}

export const validatorImage = ({
    sizeValidator,
    rectValidator,
    imageTypeValidator,
    ratioValidator,
    customizeValidator,
    otherProps,
    size,
    height,
    width,
    imgType,
    isMulti,
    info,
    i,
    url
}) => {
    let errorList = []
    // 尺寸宽高（像素）
    if (rectValidator && width && height) {
        errorList = errorList.concat(itemRectValidator({ rectValidator, width, height, i, isMulti, otherProps }))
    }

    // 宽高比例
    if (ratioValidator && width && height) {
        errorList = errorList.concat(itemRatioValidator({ ratioValidator, width, height, i, isMulti, otherProps }))
    }

    // 图片容量大小
    if (sizeValidator && size) {
        errorList = errorList.concat(itemSizeValidator({ sizeValidator, size, i, isMulti, otherProps }))
    }

    // 图片格式
    if (imageTypeValidator && imgType) {
        errorList = errorList.concat(itemImageTypeValidator({ imageTypeValidator, imgType, i, isMulti, otherProps }))
    }

    // 自定义限制
    if (customizeValidator && typeof customizeValidator === 'function') {
        const { msg, type, validator } = customizeValidator({ info, i })

        if (!validator) {
            errorList = errorList.concat({
                index: i + 1,
                type,
                msg
            })
        }
    }

    return errorList.filter(item => item).map(item2 => ({ ...item2, url, info }))
}

export const validatorImageList = ({ cleanList, value, validatorParam }) => {
    const {
        validatorNum,
        sizeValidator,
        rectValidator,
        imageTypeValidator,
        ratioValidator,
        customizeValidator,
        otherProps
    } = validatorParam

    let errorList = []

    const len = cleanList.length
    const infoList = []

    for (let i = 0; i < len; i++) {
        const currUrl = cleanList[i]?.url || ''
        const _index = cleanList[i]?._index || 0
        const info = getImageInfoFromUrl(currUrl)
        const isMulti = Array.isArray(value)
        const { size, height, width, imgType } = info || {}

        infoList.push(info)

        // 是否校验部分
        if (validatorNum && isNumber(validatorNum)) {
            if (_index >= validatorNum) {
                break
            }
        }

        const itemErrorList = validatorImage({
            sizeValidator,
            rectValidator,
            imageTypeValidator,
            ratioValidator,
            customizeValidator,
            otherProps,
            size,
            height,
            width,
            imgType,
            isMulti,
            info,
            i,
            url: currUrl
        })

        errorList = errorList.concat(itemErrorList)
    }

    return {
        errorList,
        infoList
    }
}

// 单图校验
export const singleImageValidateError = ({ singleValidate, data }) => {
    if (!data?.url || !singleValidate) {
        return {
            isError: false,
            errors: []
        }
    }

    const validatorParam = imageUrlValidatorParam(singleValidate)
    const info = getImageInfoFromUrl(data?.url) || {}
    // const validatorNum = validatorParam?.validatorNum

    const itemErrorList = validatorImage({
        ...validatorParam,
        ...info,
        isMulti: false,
        info,
        i: 0,
        url: data?.url
    })

    return {
        isError: itemErrorList.length > 0,
        errors: itemErrorList
    }
}

// 错误文本转换
export const transErrorsToMsg = errors => {
    const firstError = errors?.[0]

    switch (firstError?.type) {
        case ERROR_TYPE.SIZE:
            if (firstError?.info?.size > firstError?.validator?.maxSize * 1024 * 1024) {
                return `超出${firstError?.validator?.maxSize}M`
            }
            if (firstError?.info?.size < firstError?.validator?.minSize * 1024 * 1024) {
                return `小于${firstError?.validator?.minSize}M`
            }
            return '图片大小错误'
        case ERROR_TYPE.RECT:
            return '尺寸不符'
        case ERROR_TYPE.TYPE:
            return '不支持的格式'
        case ERROR_TYPE.RATIO:
            if (Array.isArray(firstError?.validator?.ratio)) {
                return `比例不是${firstError?.validator?.ratio.map(ra => getRatioStrByRatio(ra)).join('/')}`
            }
            return `比例不是${getRatioStrByRatio(firstError?.validator?.ratio)}`
        case ERROR_TYPE.CUSTOMIZE:
            return firstError?.msg
        default:
            return firstError?.msg || '图片错误'
    }
}

/**
 * validatorNum: 验证的数量（数组的前几个进行校验）
 * maxSize: undefined, // 最大尺寸（单位：M）
 * minSize: 0, // 最小尺寸（单位：M）
 * minWidth: 最小宽度
 * maxWidth: 最大宽度
 * minHeight: 最小高度
 * maxHeight: 最大高度
 * ratio: 宽高比例 (w / h)
 * maxRatio: 最大宽高比
 * ratioDiffScope: 允许的误差值
 * acceptTypeList: [] // 允许图片类型 ['image/jpg', 'image/png']
 * noAcceptTypeList: [] // 不允许的图片类型 ['image/gif']
 * noHint: false // 不提示，解决图片单个提示的情况
 */
export const buildImageUrlValidator = (customImageRules, noHint = false) => {
    const validatorParam = imageUrlValidatorParam(customImageRules)
    const rectValidator = validatorParam?.rectValidator

    return {
        validator(rule, value) {
            if (!value) {
                return Promise.resolve()
            }

            const cleanList = Array.isArray(value) ? clean(value) || [] : [value]

            const { errorList, infoList } = validatorImageList({ cleanList, value, validatorParam })

            // 总高度检测
            if (rectValidator?.maxTotalHeight) {
                const totalHeight = infoList.reduce((t, c) => {
                    return t + c?.height || 0
                }, 0)

                if (totalHeight > rectValidator.maxTotalHeight) {
                    // 暂时只有天猫无线描述，改成单个需要考虑
                    errorList.push({
                        msg: '图片总高度不合法'
                    })
                }
            }

            if (errorList.length > 0) {
                if (noHint) {
                    // 只有这样才不提示
                    // eslint-disable-next-line prefer-promise-reject-errors
                    return Promise.reject()
                }

                return Promise.reject(new Error(errorList[0]?.msg || '图片检验不通过'))
            } else {
                return Promise.resolve()
            }
        }
    }
}

const verifyItem = ({ info, verify }) => {
    const { size, height, width } = info || {}
    const { maxSize, minSize, maxWidth, minWidth, maxHeight, minHeight } = verify || {}
    let error = {}

    // 检查大小
    if (typeof minSize === 'number') {
        if (size < minSize * 1024 * 1024) {
            return { status: 'error', message: '无效大小' }
        }
    }

    if (typeof maxSize === 'number') {
        if (size > maxSize * 1024 * 1024) {
            return { status: 'error', message: '无效大小' }
        }
    }

    // 检查尺寸
    if (
        typeof minWidth === 'undefined' &&
        typeof maxWidth === 'undefined' &&
        typeof minHeight === 'undefined' &&
        typeof maxHeight === 'undefined'
    ) {
        return error
    }

    try {
        if (
            (minWidth && width < minWidth) ||
            (maxWidth && width > maxWidth) ||
            (minHeight && height < minHeight) ||
            (maxHeight && height > maxHeight)
        ) {
            return { status: 'error', message: '无效尺寸' }
        }
    } catch (e) {
        console.error('catchError', e)
        return { status: 'error', message: '无效尺寸' }
    }

    return error
}

export const dealMaterialImage = ({ data, verify }) => {
    if (Array.isArray(data)) {
        return data.map(item => {
            const info = getImageInfoFromUrl(item.url)

            if (info) {
                return {
                    ...item,
                    ...verifyItem({ info, verify })
                }
            }

            return item
        })
    }

    const dataInfo = getImageInfoFromUrl(data.url)

    if (dataInfo) {
        return {
            ...data,
            ...verifyItem({ info: dataInfo, verify })
        }
    }

    return data
}

export const isAutoReplaceImage = ({ url, aiFullImagesList }) => {
    try {
        const autoresize = /autoresize/.test(url)

        if (autoresize) {
            return {
                type: AUTO_PEPLACE_TYPE.AUTO
            }
        }

        const aiFullItem = aiFullImagesList?.find(item => item.newUrl === url)
        if (aiFullItem) {
            return {
                type: AUTO_PEPLACE_TYPE.AI,
                oldUrl: aiFullItem.oldUrl
            }
        }

        return false
    } catch (error) {
        console.error('error', error)
        return false
    }
}

export const getRichTextInvalidImg = (customImageRules, value) => {
    const validatorParam = imageUrlValidatorParam(customImageRules)

    if (value?.data && typeof value?.data === 'string') {
        const imglist = extractPicFromHtml(value.data)

        const cleanList = transDataToValue(imglist || [])

        const { errorList } = validatorImageList({ cleanList, value: cleanList, validatorParam })

        if (errorList.length > 0) {
            return errorList
        }
    }
    return []
}

export const buildRichTextImgValidator = customImageRules => {
    const validatorParam = imageUrlValidatorParam(customImageRules)

    return {
        validator(rule, value) {
            if (value?.data && typeof value?.data === 'string') {
                const imglist = extractPicFromHtml(value.data)

                const cleanList = transDataToValue(imglist || [])

                const { errorList } = validatorImageList({ cleanList, value: cleanList, validatorParam })

                if (errorList.length > 0) {
                    return Promise.reject(new Error('图片检验不通过'))
                }
            }
            return Promise.resolve()
        }
    }
}
